
<div class="app">
  <app-layout />
  <vue-griddle />
</div>
